import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { GhostButton, PrimaryButton } from 'ui/button';
import { Add16 } from 'ui/icons';
import { Takeover } from 'ui/workflows/takeover';
import { DRAWER_SIZES } from 'ui/workflows/drawer/constants';
import { H3, Caption, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { useModalsContext, DestinationFormSchema } from 'modules/sendingPlatforms/contexts';
import { DestinationFormSection } from './DestinationFormSection';
import { ApplicationsFormSection } from './ApplicationsFormSection';

const Container = styled.div`
  display: grid;
  grid-gap: ${spacing.base};

  &:not(:last-child) {
    margin-bottom: ${pxToRem(40)};
  }
`;

const CaptionLightText = styled(Caption)`
  color: ${colors.textSecondary};
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: ${spacing.base};
  width: 100%;
`;

export const DestinationTakeover = () => {
  const { hideModal } = useModalsContext();
  const {
    handleSubmit,
    formState: { isValid },
  } = useFormContext<DestinationFormSchema>();

  const onSubmit = (values: DestinationFormSchema) => {
    console.log({ values }, 'DestinationTakeover onSubmit');
  };

  return (
    <Takeover
      Body={
        <>
          <Container>
            <div>
              <H3>Destination</H3>
              <CaptionLightText>Tell us where to send your push messages.</CaptionLightText>
            </div>
            <DestinationFormSection />
          </Container>
          <Container>
            <div>
              <H3>Applications</H3>
              <CaptionLightText>
                Add an application to serve as the target destination for your push messages.
              </CaptionLightText>
            </div>
            <ApplicationsFormSection />
          </Container>
        </>
      }
      Footer={
        <FooterContainer>
          <GhostButton
            onClick={() => {
              hideModal();
            }}
          >
            Cancel
          </GhostButton>
          <PrimaryButton isDisabled={!isValid} onClick={handleSubmit(onSubmit)}>
            <Add16 />
            Add destination
          </PrimaryButton>
        </FooterContainer>
      }
      isLoading={false}
      isMainApp
      isOverlay
      size={DRAWER_SIZES.LARGE}
      onClose={() => {
        hideModal();
      }}
      title={'Custom push platform'}
    />
  );
};
